import { useEffect, EffectCallback } from 'react';

/**
 * Runs an effect exactly once on mount — the hooks equivalent of
 * `componentDidMount`. The callback may return a cleanup function, which
 * will run on unmount (like `componentWillUnmount`).
 *
 * Using this instead of `useEffect(fn, [])` makes intent explicit and
 * silences exhaustive-deps lint warnings about missing dependencies.
 */
const useMountEffect = (effect: EffectCallback): void => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(effect, []);
};

export default useMountEffect;
